import { OnEventDispatcher } from "../../core/on-event-dispatcher";

export class BaseComponent extends OnEventDispatcher {
  parent: JQuery<HTMLElement>;
  elm: JQuery<HTMLElement>;
	constructor(parent:JQuery<HTMLElement>, prepend:boolean = false) {
		super();
		this.parent = parent;
		if(prepend) {
			this.elm = $(`<div class='basecomponent'></div>`).prependTo(parent);
		} else {
			this.elm = $(`<div class='basecomponent'></div>`).appendTo(parent);
		}
	}
	destroy() {
		if(this.elm!=null) {
			this.elm.remove();
		}
	}
}
